import { NgModule } from "@angular/core";
import { InventoryInputFormComponent } from './inventory-input-form/inventory-input-form.component';
import { DynamicInventoryInputComponent } from './dynamic-inventory-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { InventoryInputDesignComponent } from './inventory-input-design/inventory-input-design.component';
import { InventoryInputResultComponent } from './inventory-input-result/inventory-input-result.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { InventoryInputService } from './inventory-input.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CodeScannerModule } from '../../code-scanner/code-scanner.module';
import { MatCardModule } from '@angular/material/card';
import { InventoryInputArticlesDialog } from './inventory-input-articles-dialog/inventory-input-articles-dialog.component';
import { DropdownModule } from '../../dropdown/dropdown.module';
import { FamocoScanLaserModule } from '../../famoco-scan-laser/famoco-scan-laser.module';
import { KendoModule } from '../../kendo.module';
import { NewlandScannerModule } from '../../newland-scanner/newland-scanner.module';

@NgModule({
    declarations: [
        InventoryInputResultComponent,
        InventoryInputDesignComponent,
        InventoryInputFormComponent, DynamicInventoryInputComponent,
        InventoryInputArticlesDialog
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatCardModule,
        CodeScannerModule,
        DropdownModule,
        FamocoScanLaserModule,
        KendoModule,
        NewlandScannerModule
    ],
    entryComponents: [
        DynamicInventoryInputComponent,
        InventoryInputArticlesDialog
    ],
    providers: [
        InventoryInputService
    ]
})
export class InventoryInputModule {}